import { ApiProperty } from "@nestjs/swagger";

export class DeviceCodeAndInfoRequest {
    @ApiProperty()
    deviceCode: string;
    @ApiProperty()
    deviceName: string;
    @ApiProperty()
    deviceUid: string;
    @ApiProperty()
    apiKey: string;
    @ApiProperty()
    deptName: string;
    @ApiProperty()
    deptCode: string;
    @ApiProperty()
    module: string;
    @ApiProperty()
    subModule: string;
    @ApiProperty()
    unit: number;
}